import { PriceFrequency } from '@energy-retailer/constants';

const getPriceFrequencyText = ({
  priceFrequency,
}: {
  priceFrequency?: PriceFrequency;
}) => {
  switch (priceFrequency) {
    case PriceFrequency.Quarterly:
      return 'quarter';
    case PriceFrequency.Monthly:
      return 'month';
    case PriceFrequency.Weekly:
      return 'week';
    case PriceFrequency.Yearly:
    default:
      return 'year';
  }
};

export { getPriceFrequencyText };
